/**
 * Vonex Software Front-End Boilerplate
 *
 * @package	Vonex Boilerplate
 * @author	Vonex Dev Team
 * @since	Version 1.0.0
 * @reference https://bitbucket.org/vonex/styleguide/src/master/
 *
 * Used to work with API endpoints.
 *
 */

import axios from 'axios'
import Mgr from '@/services/SecurityService'
import * as LDClient from 'launchdarkly-js-client-sdk'
import store from '@/store/store'

const user = new Mgr()

const HTTP = axios.create({
  baseURL: `${process.env.API}/`,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'
  },
  params: {}
})

user.getIdToken().then(
  accessToken => {
    HTTP.defaults.headers.common.Authorization = `Bearer ${accessToken.id_token}`

    const user = {
      key: accessToken.profile.email
    }

    const client = LDClient.initialize(process.env.LAUNCHDARKLY, user)

    client.on('ready', function () {
      store.dispatch('featureFlag/setAllFlags', client.allFlags())
    })

    client.on('change', function () {
      store.dispatch('featureFlag/setAllFlags', client.allFlags())
    })
  },
  err => {
    console.log(err)
  }
)

export default HTTP
